// packages/data/src/redux-store/metadata/utils.ts
function selectorArgsToStateKey(args) {
  if (args === void 0 || args === null) {
    return [];
  }
  const len = args.length;
  let idx = len;
  while (idx > 0 && args[idx - 1] === void 0) {
    idx--;
  }
  return idx === len ? args : args.slice(0, idx);
}
export {
  selectorArgsToStateKey
};
//# sourceMappingURL=utils.mjs.map
